import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextInput from "../form/TextInput";
import { Button } from "../ui/button";
import { useToast } from "../../hooks/use-toast";
import { useAuth } from "../../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "@/context/AuthContext";
import { Dialog, DialogContent } from "../ui/dialog";
import ResetPasswordForm from "./ResetPasswordForm";
import { useCurrentUser } from "@/context/UserContext";
import PasswordInput from "../form/PasswordInput";
import { LandingPageTab } from "./LandingPage";
import XorexLogo from "../../assets/images/xorex-logo.png";
interface Props {
  setTab: Dispatch<SetStateAction<LandingPageTab>>;
}
function LoginForm({ setTab }: Props) {
  const { toast } = useToast();
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [err, setErr] = useState<string>("");
  const { login } = useAuthContext();
  const { setCurrentUser } = useCurrentUser();
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      const newUser = await login(email, password);
      const { user, isNewUser } = newUser;

      // Check if new user first
      if (isNewUser && user.role === "STAFF") {
        console.log("New user detected. Redirecting to reset password page");
        toast({
          title: "Welcome! Please set your password",
          description: "For security reasons, you need to set a new password.",
        });
        setCurrentUser({
          email: user.email,
          fullName: user.fullName,
          id: user.id,
          role: user.role,
          hireDate: user.employmentInfo.hireDate,
        });
        return;
      }
      console.log("hiredate", user.hireDate);
      // Regular login flow

      toast({
        title: "Login successful!",
        description: `Welcome ${user.fullName}`,
      });

      if (user.role === "ADMIN") {
        console.log("Redirecting to admin page");
        setCurrentUser({
          email: user.email,
          fullName: user.fullName,
          id: user.id,
          role: user.role,
        });

        navigate("/admin");
      } else if (user.role === "STAFF") {
        setCurrentUser({
          email: user.email,
          fullName: user.fullName,
          id: user.id,
          role: user.role,
          hireDate: user.employmentInfo.hireDate,
        });

        console.log("Redirecting to staff page");

        navigate("/staff");
      } else {
        console.error("Unknown user role:", user.role);
      }
    } catch (err: any) {
      console.log(err);
      toast({
        title: "Login Error",
        description: err.response.data.message,
        variant: "destructive",
      });
    }
  };

  const validateForm = () => {
    if (email.length === 0 || password.length === 0) {
      setErr("Email and Password are required.");
      return false;
    }
    return true;
  };

  const handleForgotPassword = () => {
    setTab(LandingPageTab.FORGOT);
  };

  return (
    <div className="w-full h-full flex flex-col gap-4 items-center justify-center">
      <div className="flex flex-col gap-2">
        <div className="tracking-wide font-extrabold text-red-800 text-4xl text-center mt-2 mb-2">
          Xorex@HR
        </div>
        <div className="text-2xl font-bold text-center">Welcome Back</div>
        <div className="text-gray-500 text-center">
          Please enter your details to sign in.
        </div>
      </div>
      <form
        className=" mt-10 w-full h-max flex flex-col gap-6 items-center max-w-[400px]"
        onSubmit={handleSubmit}
      >
        <TextInput
          label="Email"
          placeholder="Enter your email address"
          value={email}
          setValue={setEmail}
          type="email"
        />
        <PasswordInput
          label="Password"
          value={password}
          setValue={setPassword}
          placeholder="Enter your password"
        />
        <div className="w-full flex flex-row justify-between items-center">
          <div className="text-red-500 text-sm transition-all">{err}</div>
          <Button
            type="button"
            variant="link"
            className="self-end underline text-gray-500 hover:text-black"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </Button>
        </div>
        <Button
          type="submit"
          className="w-full"
          disabled={email.length === 0 || password.length === 0}
        >
          Login
        </Button>
      </form>
    </div>
  );
}

export default LoginForm;
